import React from "react";
import { sprintf } from 'sprintf-js';

import { ControlGroup } from "@blueprintjs/core";
import IOption from "common/models/IOption";
import { iDef } from "core/util/TypeUtils";
import { IWidgetProps } from "decorator-form";
import ColorPickerWidget from "./ColorPickerWidget";
import ButtonSelect from "./common/ButtonSelect";
import DropdownSelect from "./common/DropdownSelect";
import CssUnitWidget from "./CssUnitWidget";

interface IBorder {
	width: string;
	style: string;
	color: string;
}

const styleOptions: IOption[] = [
	{label: "Solid", value: "solid", default: true},
	{label: "Dotted", value: "dotted"},
	{label: "Dashed", value: "dashed"},
	{label: "None", value: "none"}
];

export default class BorderWidget extends React.PureComponent<IWidgetProps<string>> {
	public render() {
		const border = this.fromValue(this.props.value);

		return (
			<ControlGroup fill={true}>
				<DropdownSelect
					value={border.style}
					onChange={(value) => this.onChange(value, border, "style")}
					readonly={false}
					autofocus={false}
					options={styleOptions}
				/>
				<CssUnitWidget
					value={border.width}
					onChange={(value) => this.onChange(value, border, "width")}
					readonly={false}
					autofocus={false}
					options={undefined}
				/>
				<ColorPickerWidget
					value={border.color}
					onChange={(value) => this.onChange(value, border, "color")}
					readonly={false}
					autofocus={false}
					options={styleOptions}
				/>
			</ControlGroup>
		);
	}

	private onChange(value: string, border: IBorder, part: string) {
		const newBorder = {...border, [part]: value};
		this.props.onChange(this.toValue(newBorder));
	}

	private toValue(border: IBorder): string {
		return sprintf("%s %s %s", border.width, border.style, border.color);
	}

	private fromValue(value: string): IBorder {
		// value.match(/^(\S+)\s(\S+)\s(.*)/).slice(1)
		const parts = (iDef(value) ? value : "1px none rgba(0, 0, 0, 1)").split(" ");
		return {width: parts[0], style: parts[1], color: parts.slice(2).join(" ")};
	}
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/BorderWidget.tsx